// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeIndex',
    component: () => import('@/views/index/IndexView.vue')
  },
  {
    path: '/brand-list',
    name: 'brand-list',
    component: () => import('@/views/index/BrandListView.vue')
  },
  {
    path: '/hot',
    name: 'hot',
    component: () => import('@/views/index/HotListView.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/cart/IndexView.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/notice/IndexView.vue')
  },
  {
    path: '/notice_detail',
    name: 'notice_detail',
    component: () => import('@/views/notice/DetailView.vue')
  },
  {
    path: '/addOrder',
    name: 'addOrder',
    component: () => import('@/views/order/AddOrder.vue')
  },
  // {
  //   path: '/orderList',
  //   name: 'orderList',
  //   component: () => import('@/views/order/OrderList.vue')
  // },
  {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import('@/views/order/OrderPay.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/products/ProductList.vue')
  },
  {
    path: '/products/:id',
    name: 'product-detail',
    component: () => import('@/views/products/ProductDetail.vue')
  },
  {
    path: '/user/order',
    name: 'userOrder',
    component: () => import('@/views/user/Order.vue')
  },
  {
    path: '/user/personal',
    name: 'userPersonal',
    component: () => import('@/views/user/Personal.vue')
  },
  {
    path: '/user/purchase',
    name: 'userPurchase',
    component: () => import('@/views/user/Purchase.vue')
  },
  {
    path: '/user/sale',
    name: 'userSale',
    component: () => import('@/views/user/Sale.vue')
  },
  {
    path: '/user/address',
    name: 'userAddress',
    component: () => import('@/views/user/Address.vue')
  },
  {
    path: '/user/info',
    name: 'userInfo',
    component: () => import('@/views/user/Info.vue')
  },
  {
    path: '/user/scorelog',
    name: 'userScorelog',
    component: () => import('@/views/user/Scorelog.vue')
  },
  {
    path: '/user/moneylog',
    name: 'userMoneylog',
    component: () => import('@/views/user/Moneylog.vue')
  },
  {
    path: '/user/recharge',
    name: 'userRecarge',
    component: () => import('@/views/user/Recharge.vue')
  },
  {
    path: '/specList',
    name: 'specList',
    component: () => import('@/views/spec/SpecList.vue')
  },
  {
    path: '/future',
    name: 'future',
    component: () => import('@/views/future/Index.vue')
  },
  {
    path: '/future/detail',
    name: 'futureDetail',
    component: () => import('@/views/future/Detail.vue')
  },
  {
    path: '/user/future',
    name: 'userFuture',
    component: () => import('@/views/user/Future.vue')
  },
  {
    path: '/user/futureOrder',
    name: 'userFutureOrder',
    component: () => import('@/views/user/FutureOrder.vue')
  },
  {
    path: '/user/futureQuote',
    name: 'userFutureQuote',
    component: () => import('@/views/user/FutureQuote.vue')
  },
  {
    path: '/future/addOrder',
    name: 'futureAddOrder',
    component: () => import('@/views/future/AddOrder.vue')
  },
  {
    path: '/future/create',
    name: 'futureCreate',
    component: () => import('@/views/future/Create.vue')
  },
  {
    path: '/express',
    name: 'express',
    component: () => import('@/views/express/Index.vue')
  },
  {
    path: '/express/detail',
    name: 'expressDetail',
    component: () => import('@/views/express/Detail.vue')
  },
  // 404页面路由 - 必须放在最后
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/error/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router